<template>
	<div class="transaction">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 text-gray mt-3 mt-md-0">
					<ml-menu></ml-menu>
					<div class="col-12 p-0 pb-3">
						<div class="container p-0 p-md-2">
							<div class="row">
								<div class="col-6 col-md-6 mt-5 mt-md-5">
									<div class="col-md-12 d-md-flex pl-0 mt-2">
										<h4 id="test">Transaksi</h4>
									</div>
								</div>
								<div class="col-6 pr-0 col-md-6 mt-5 mt-md-5 d-none d-sm-block">
									<nav aria-label="breadcrumb">
										<ol class="breadcrumb float-right">
											<li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
											<li class="breadcrumb-item active" aria-current="page"><a href="javascript:;">Transaksi</a></li>
										</ol>
									</nav>
								</div>
							</div>
							<div class="row" id="tab-transaksi">
								<div class="col-12 mb-2">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12">
												<div class="background-white rounded cus-box-shadow overflow-auto">
													<ul class="nav nav-pills font-size-11 font-size-sm-10 stock-product-slider" id="pills-tab" role="tablist">
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray" href="" :class="{active: status===''}" @click.prevent="pilihStatus('')"><p class="m-0">Semua Transaksi</p></a>
														</li>
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray" href="" :class="{active: status===0}" @click.prevent="pilihStatus(0)"><p class="m-0">Menunggu Pembayaran</p></a>
														</li>
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray" href="" :class="{active: status==3}" @click.prevent="pilihStatus(3)"><p class="m-0">Pembayaran Sukses</p></a>
														</li>
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray pl-0 pr-0 pl-md-3 pr-md-3" href="" :class="{active: status==4}" @click.prevent="pilihStatus(4)"><p class="m-0 pl-2 pr-2 pr-md-2">Sedang Diproses</p></a>
														</li>
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray pl-0 pr-0 pl-lg-4 pr-lg-4" href="" :class="{active: status==6}" @click.prevent="pilihStatus(6)"><p class="m-0 pl-md-4 pl-3 pr-2 pr-md-4">Sudah Dikirim / Diambil</p></a>
														</li>
														<li class="nav-item border-right border-gray-2">
															<a class="nav-link text-gray pl-0 pr-0 pl-md-2 pr-md-2" href="" :class="{active: status==9}" @click.prevent="pilihStatus(9)"><p class="m-0 pl-2 pr-2 pr-md-2">Transaksi Selesai</p></a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="tab-content" id="pills-tabContent">
								<div class="tab-pane fade show active" id="semua-transaksi" role="tabpanel" aria-labelledby="semua-transaksi-tab">
									<div class="row">
										<div class="col-12 col-md-12 mb-2 mt-2">
											<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
												<div class="col-12 p-0 d-flex pt-3 pl-4">
													<div class="col-12 p-0">
														<div class="row">
															<div class="col-6 col-md-6 font-size-sm-11">
																<p>Riwayat Transaksi</p>
															</div>
															<!-- <div class="col-6 col-md-6 mt-n1 pr-4">
																<button class="btn btn-mila text-white font-size-10 float-right box-purple" data-toggle="modal" data-target="#modalChangeProfile"><img src="assets/icon/excel.png" class="img-fluid pr-2">Export Data</button>
															</div> -->
														</div>
													</div>
												</div>
											</div>
											<div class="col-12 p-0 background-gray-light rounded-bottom cus-box-shadow">
												<a class="text-gray" data-toggle="collapse" href="#collapseFilterStokSerial" role="button" aria-expanded="false" aria-controls="collapseExample">
													<div class="col-12 p-0 d-flex pt-3 pl-4 pb-2">
														<div class="col-12 p-0">
															<div class="row font-size-sm-10 font-size-12">
																<div class="col-12 col-md-12 mt-n1">
																	<img src="assets/icon/filter.png" class="pr-1">Filter
																</div>
															</div>
														</div>
													</div>
												</a>
												<div class="col-12 col-md-12 mt-1 font-size-sm-9 font-size-11 collapse" id="collapseFilterStokSerial">
													<div class="row">
														<div class="col-12 col-lg-6 col-md-9 pt-2 pt-md-0">
															<div class="row">
																<div class="col-4 mt-1 pl-4">
																	<span>Tanggal</span>
																</div>
																<div class="col-4 col-lg-3 col-md-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple fullscreen-when-on-mobile" v-model="tanggalAwal" placeholder="Dari Tanggal" bootstrap-styling/>
																</div>
																<div class="col-4 col-lg-3 col-md-4 pl-0 pr-2">
																	<datepicker :language="indonesia" input-class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple fullscreen-when-on-mobile" v-model="tanggalAkhir" placeholder="Sampai Tanggal" bootstrap-styling/>
																</div>
															</div>
														</div>
														<div class="col-12 col-lg-6 col-md-9 pt-2 pt-md-0 pl-md-0 pr-md-4">
															<div class="row">
																<div class="col-4 mt-1 pl-4 pl-lg-2">
																	<span> Tipe Pengambilan</span>
																</div>
																<div class="col-8 col-lg-6 col-md-4 p-0 pr-2">
																	<select class="form-control form-control-sm font-size-9 box-purple text-gray" v-model="tipe.value">
																		<option v-for="filter in pilihanTipe" :key="filter.value" :value="filter.value">{{ filter.name }}</option>
																	</select>
																</div>
															</div>
														</div>
													</div>
													<div class="row pb-3">
														<div class="col-12 col-lg-6 col-md-9 pt-2 pt-md-3">
															<div class="row">
																<div class="col-4 mt-1 pl-4">
																	<span>Kode Transaksi</span>
																</div>
																<div class="col-8 col-lg-6 col-md-4 p-0 pr-2 mt-2 mt-md-0">
																	<input type="text" v-model="kode.value" class="form-control form-control-sm font-size-9 box-purple text-gray" placeholder="Kode Transaksi">
																</div>
															</div>
														</div>
														<div class="col-12 col-lg-6 col-md-9 pt-2 pt-md-3 pl-md-0 pr-md-4">
															<div class="row">
																<div class="col-4 mt-1 pl-4 pl-lg-2">
																	<span>Nama Pembeli</span>
																</div>
																<div class="col-8 col-lg-6 col-md-4 p-0 pr-2 mt-2 mt-md-0">
																	<input type="text" v-model="nama.value" class="form-control form-control-sm font-size-9 box-purple text-gray" placeholder="Nama Pembeli">
																</div>
															</div>
														</div>
														<div class="col-12 col-md-2 col-lg-4 offset-lg-7 pt-2 pt-md-3 pr-md-5 pr-lg-3">
															<div class="row">
																<div class="col-md-12">
																	<button class="btn btn-mila text-white font-size-10 pt-1 pb-1 float-right pl-5 pr-5 box-purple ml-3" @click="cari">Cari</button>
																	<button class="btn btn-mila text-white font-size-10 pt-1 pb-1 float-right pl-5 pr-5 box-purple" @click="reset()">Reset</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- Transaksi Data -->
									<div class="row">
										<div class="col-12 col-md-12">
											<div class="col-12 p-0">
												<div class="row" v-show="transactionResults.length == 0 ">
													<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3" v-for="(index) in 2" v-bind:key="index">
														<div class="col-12 p-0 pb-2 background-white rounded cus-box-shadow">
															<vcl :width='300' :height='35' class="background-white rounded cus-box-shadow ">
																<rect x="252" y="-2" rx="5" ry="12" width="50" height="9" />  
																<rect x="7" y="5" rx="2" ry="2" width="20" height="5" />
																<rect x="7" y="15" rx="2" ry="2" width="45" height="4" />
																<rect x="7" y="21" rx="2" ry="2" width="35" height="4" />
																<rect x="88" y="21" rx="1" ry="1" width="7" height="4" />
																<rect x="95" y="21" rx="2" ry="2" width="55" height="4" />
																<rect x="178" y="21" rx="2" ry="2" width="40" height="4" />
																<rect x="257" y="21" rx="1" ry="1" width="37" height="10" />
																<rect x="7" y="27" rx="2" ry="2" width="40" height="4" />
																<rect x="88" y="27" rx="1" ry="1" width="7" height="4" />
																<rect x="95" y="27" rx="2" ry="2" width="50" height="4" />
																<rect x="178" y="27" rx="2" ry="2" width="35" height="4" />
															</vcl>
														</div>
													</div>
												</div>
												<!-- data kosong -->
												<div class="row" v-if="transactionResults == 'error'">
													<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3">
														<div class="col-12 p-0 pb-2 background-white rounded cus-box-shadow">
															<div class="col-12 p-0 d-flex pb-2 pl-4">
																<div class="col-12 p-0">
																	<div class="row">
																		<div class="col-md-12 col-12 mt-1 text-center">
																			<img src="assets/icon/stock_empty.svg" width="100px;" class="mt-n3">
																			<p class="mb-n1 font-size-sm-11 font-size-12">Data Tidak Tersedia</p>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="row" v-else>
													<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3" v-for="(value, index) in transactionResults" v-bind:key="index">
														<div class="col-12 p-0 pb-2 background-white rounded cus-box-shadow">
															<span :class="value.trx_status | toStatusClass" class="pt-1 pb-2 pl-2-green float-right text-white font-size-9 rounded-bot-left-pill trans-badge text-center">{{ value.trx_status | toStatus}}</span>
															<div class="col-12 p-0 d-flex pb-2 pl-4">
																<div class="col-12 p-0 mt-n3">
																	<div class="row">
																		<div class="col-md-3 col-12">
																			<p class="text-gray font-size-11">#{{ value.trx_code }}</p>
																			<div class="font-size-sm-9 font-size-10">{{value.trx_datetime | tanggaljam }}</div>
																			<p class="mb-n1 font-size-sm-11 font-size-12">{{ value.trx_buyer_name}}</p>
																			<span class="font-size-sm-9 font-size-10">{{ value.trx_buyer_mobilephone }}</span>
																		</div>
																		<div class="col-md-4 col-10 pt-md-5 pl-md-4">
																			<div class="pt-2">
																				<div class="pt-1 font-size-sm-9 font-size-10"><img src="assets/icon/truck.png" class="img-fluid pr-1">Pengambilan : {{ value.trx_shipping_method | shipping }}</div>
																				<div class="font-size-sm-9 font-size-10"><img src="assets/icon/dompet.png" class="img-fluid pr-1">Pembayaran : {{value.trx_payment_method | paymentMethod}}</div>  
																			</div>
																		</div>
																		<div class="col-md-3 pt-md-5 col-6 pb-2 pb-md-0 pr-0">
																			<div class="pt-2">
																				<div class="pt-1 font-size-sm-9 font-size-10">Total Transaksi</div>
																				<div class="font-size-sm-10 text-purple font-size-11">{{value.trx_price_grand_total | toRupiah}}</div>
																			</div>
																		</div>
																		<div class="col-md-2 col-6 mt-1 mt-md-0 pt-md-5 pl-md-4">
																			<div class="pt-2">
																				<button class="ml-n2 mt-1 btn btn-outline-purple btn-block font-size-sm-10 box-purple" @click="detailTransaksi(value.trx_id,value.trx_status)">DETAIL</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- pagination -->
							<div class="row" v-if="transactionPagination.total_data > 0">
								<div class="col-12 col-md-12 mt-3">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12 col-md-12">
												<div class="row">
													<div class="col-9 offset-1 col-md-12 ml-0 ml-md-0">
														<ul class="pagination float-md-left">
															<li v-if="transactionPagination.first_page==true" @click="goToPage(1)">
																<a class="page-link background-mila rounded-left" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png"></span>
																</a>
															</li>
															<li v-if="transactionPagination.prev>=1" @click="goToPage(transactionPagination.prev)">
																<a class="page-link background-mila" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back.png"></span>
																</a>
															</li>
															<li @click="goToPage(page)" v-for="(page,index) in transactionPagination.detail" :key="index"><span class="page-link text-purple" :class="{active:page==transactionPagination.current}" >{{ page }}</span></li>
															<li v-if="transactionPagination.next != 0" @click="goToPage(transactionPagination.next)">
																<a class="page-link background-mila" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
															<li v-if="transactionPagination.last_page==true" @click="goToPage(transactionPagination.total_page)">
																<a class="page-link background-mila rounded-right" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
														</ul>
														<ul class="pagination float-md-right" :class="[transactionPagination.total_page==1 || transactionPagination.total_page==0  ? 'mt-md-4 mt-lg-0' : 'mt-md-n2 mt-lg-0']">
															<li @click="refresh">
																<a class="page-link background-mila rounded text-white" href="#" aria-label="Refresh">
																	<span aria-hidden="true" class="font-size-10"><img src="assets/icon/refresh.png" class="pr-1">Refresh</span>
																</a>
															</li>
															<li class="">
																<div class="btn-group">
																	<button type="button" class="btn btn-outline-purple dropdown-toggle background-white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{currentLimit}}
																		<div class="dropdown-menu">
																			<span class="dropdown-item text-gray" v-for="(limit, index) in limit" :key="index" @click="getLimit(limit)">{{limit}}</span>
																		</div>
																	</button>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<VModal ref="ModalDetilTransaksi" type="modal-xl">
			<template v-slot:title >
				<span style="text-transform: uppercase"> DATA TRANSAKSI {{transactionOne.trx_buyer_name}} </span>
			</template>
			<template v-slot:tabMenu>
				<div class="row">
					<div class="col-12 pb-3 pl-3 pr-3 pb-0">
						<div class="col-12 border-bottom pl-0 pr-0">
							<div class="d-flex flex-row">
								<div class="">
									<button :class="[tabMenu== 'detail' ? 'btn-mila' : '']" @click="ChooseTabMenu('detail')" class="font-size-11 font-size-sm-10 btn no-rounded text-gray no-box-shadow pt-2 pb-2" id="btnDetailTransaksi" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="detailTransaksi">
										Detail Transaksi
									</button>
								</div>
								<div class="">
									<button :class="[tabMenu== 'history' ? 'btn-mila' : '']" @click="ChooseTabMenu('history')" class="font-size-11 font-size-sm-10 btn no-rounded text-gray no-box-shadow pt-2 pb-2" id="btnStatusTransaksi" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="statusTransaksi">
										Status Transaksi
									</button>
								</div>
								<div class="" v-if="transactionOne.trx_status==3">
									<button :class="[tabMenu== 'proses' ? 'btn-mila' : '']" @click="()=>{ChooseTabMenu('proses');}"  class="font-size-11 font-size-sm-10 btn no-rounded text-gray no-box-shadow pt-2 pb-2" id="btnProsesOrder" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="prosesOrder">
										Proses Order
									</button>
								</div>
								<div class="" v-if="transactionOne.trx_status==3">
									<button :class="[tabMenu== 'cancel' ? 'btn-mila' : '']" @click="()=>{ChooseTabMenu('cancel');}"  class="font-size-11 font-size-sm-10 btn no-rounded text-gray no-box-shadow pt-2 pb-2" id="btnProsesOrder" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="prosesOrder">
										Batalkan Order
									</button>
								</div>
								<div class="col-4 col-md-3 col-lg pl-0 pr-0" v-if="transactionOne.trx_status==4">
									<button :class="[tabMenu== 'konfPickup' ? 'btn-mila' : '']" @click="ChooseTabMenu('konfPickup')" class="font-size-11 font-size-sm-10 btn no-rounded text-gray no-box-shadow pt-2 pb-2" id="btnProsesOrder" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="prosesOrder">
										Konfirmasi {{ transactionOne.trx_shipping_method==0 ? 'Pengambilan' : 'Pengiriman' }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:body>
				<TransactionDetail v-if="tabMenu=='detail'"/>
				<TransactionHistory v-else-if="tabMenu=='history'"/>
				<ProsesOrder v-else-if="tabMenu=='proses'"/>
				<RejectOrder v-else-if="tabMenu=='cancel'"/>
				<KonfirmPickup v-else-if="tabMenu=='konfPickup'" :paramPickUp="paramPickUp"/>
			</template>
			<template v-slot:footer v-if="['proses', 'konfPickup', 'cancel'].includes(tabMenu)">
				<div class="row px-0 px-lg-4 pb-1 pt-2 pt-lg-3" v-if="tabMenu=='proses'">
					<div class="col-md-3 offset-md-6 text-center pb-2">
						<button @click="()=>{$refs.ModalDetilTransaksi.modalHide();}" class="btn btn-danger btn-block font-size-10"><i class="fas fa-times mr-2"></i>Batal</button>
					</div>
					<div class="col-md-3 text-center pb-2">
						<button @click="prosesOrder(4)" class="btn btn-green btn-block font-size-10 text-white"><i class="fas fa-arrow-circle-right mr-2"></i>Proses Order</button>
					</div>
				</div>
				<div class="row px-0 px-lg-4 pb-1 pt-2 pt-lg-3" v-if="tabMenu=='cancel'">
					<div class="col-md-3 offset-md-6 text-center pb-2">
						<button @click="()=>{$refs.ModalDetilTransaksi.modalHide();}" class="btn btn-danger btn-block font-size-10"><i class="fas fa-times mr-2"></i>Batal</button>
					</div>
					<div class="col-md-3 text-center pb-2">
						<button @click="prosesOrder(5)" class="btn btn-green btn-block font-size-10 text-white"><i class="fas fa-arrow-circle-right mr-2"></i>Batalkan Order</button>
					</div>
				</div>
				<div class="row px-0 px-lg-4 pb-1 pt-2 pt-lg-3" v-else-if="tabMenu=='konfPickup'">
					<div class="col-md-3 offset-md-6 text-center pb-2">
						<button @click="()=>{$refs.ModalDetilTransaksi.modalHide();}" class="btn btn-danger btn-block font-size-10"><i class="fas fa-times mr-2"></i>Batal</button>
					</div>
					<div class="col-md-3 text-center pb-2">
						<button @click="cekPickup" class="btn btn-green btn-block font-size-10 text-white"><i class="fas fa-arrow-circle-right mr-2"></i>Konfirm</button>
					</div>
				</div>
			</template>
		</VModal>
		<VModal ref="ProsesOrderEror">
			<template v-slot:header><div></div></template>
			<template v-slot:body>
				<ConfirmModal image='error'>
					<template v-slot:konfirmTitle><span style="font-weight: 600;">Oops!</span></template>
					<template v-slot:konfirmContent><span style="text-transform: capitalize;">{{ProsesOrderAlert}}</span></template>
				</ConfirmModal>
			</template>
			<template v-slot:footer>
				<div class="d-md-flex align-items-center">
					<div class="col-8 offset-2 col-lg-3 offset-lg-9 col-md-4 offset-md-4 pb-2 mt-2">
						<button @click="()=>{$refs.ProsesOrderEror.modalHide(); resetErrorProsesOrder();}" class="btn btn-mila btn-block font-size-10">OK</button>
					</div>
				</div>
			</template>
		</VModal>
		<VModal ref="konfirmasi">
			<template v-slot:header><div></div></template>
			<template v-slot:body>
				<ConfirmModal>
					<template v-slot:konfirmTitle><span style="font-weight: 600;">Konfirmasi Proses Order</span></template>
					<template v-slot:konfirmContent>Apakah anda yakin ingin memproses order a/n <span style="text-transform: capitalize; font-weight: bold;">{{transactionOne.trx_buyer_name}}, Kode Transaksi {{transactionOne.trx_code}}?</span></template>
				</ConfirmModal>
			</template>
			<template v-slot:footer>
				<div class="row">
					<div class="col-12 text-center pb-2">
						<button @click="prosesOrderSerial" type="button" class="btn btn-mila font-size-10 pl-4 pr-4 mt-3 ml-3 float-md-right">Ya, Saya Yakin</button>
						<button @click="$refs.konfirmasi.modalHide()" type="button" class="btn btn-outline-danger font-size-10 pl-4 pr-4 mt-3 float-md-right">Batal</button>
					</div>
				</div>
			</template>
		</VModal>
		<VModal ref="konfirmasiPembatalan">
			<template v-slot:header><div></div></template>
			<template v-slot:body>
				<ConfirmModal>
					<template v-slot:konfirmTitle><span style="font-weight: 600;">Konfirmasi Pembatalan Order</span></template>
					<template v-slot:konfirmContent>Apakah anda yakin ingin membatalkan order a/n <span style="text-transform: capitalize; font-weight: bold;">{{transactionOne.trx_buyer_name}}, Kode Transaksi {{transactionOne.trx_code}}?</span></template>
				</ConfirmModal>
			</template>
			<template v-slot:footer>
				<div class="row">
					<div class="col-12 text-center pb-2">
						<button @click="rejectOrder" type="button" class="btn btn-mila font-size-10 pl-4 pr-4 mt-3 ml-3 float-md-right">Ya, Saya Yakin</button>
						<button @click="$refs.konfirmasiPembatalan.modalHide()" type="button" class="btn btn-outline-danger font-size-10 pl-4 pr-4 mt-3 float-md-right">Batal</button>
					</div>
				</div>
			</template>
		</VModal>
		<VModal ref="konfirmasiPickup">
			<template v-slot:header><div></div></template>
			<template v-slot:body>
				<ConfirmModal>
					<template v-slot:konfirmTitle><span style="font-weight: 600;">Konfirmasi {{ transactionOne.trx_shipping_method==0 ? 'Pengambilan' : 'Pengiriman' }}</span></template>
					<template v-slot:konfirmContent>
						<span v-if="transactionOne.trx_shipping_method==1">Apakah Anda sudah melakukan pengiriman dengan nomor resi {{paramPickUp.shipping_courier_number}} ?</span>
						<span v-if="transactionOne.trx_shipping_method==0">Apakah Pesanan Anda sudah Diambil oleh {{paramPickUp.taken_by}} pada Tanggal {{paramPickUp.taken_date | tanggal}}?</span>
					</template>
				</ConfirmModal>
			</template>
			<template v-slot:footer>
				<div class="row">
					<div class="col-12 text-center pb-2">
						<button @click="PickupKonf" type="button" class="btn btn-mila font-size-10 pl-4 pr-4 mt-3 ml-3 float-md-right">Ya, Sudah </button>
						<button @click="$refs.konfirmasiPickup.modalHide()" type="button" class="btn btn-outline-danger font-size-10 pl-4 pr-4 mt-3 float-md-right">Batal</button>
					</div>
				</div>
			</template>
		</VModal>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import VModal from '@/components/VModal'
import TransactionHistory from '@/views/transaction/TransactionHistory'
import ProsesOrder from '@/views/transaction/ProsesOrder'
import TransactionDetail from '@/views/transaction/TransactionDetail'
import RejectOrder from '@/views/transaction/RejectOrder'
import KonfirmPickup from '@/views/transaction/KonfirmPickup'
import ConfirmModal from '@/views/transaction/ConfirmModal'
import moment from 'moment'

export default {
	name:'Transaction',
	components:{
		VModal, TransactionHistory, ProsesOrder, TransactionDetail, KonfirmPickup, ConfirmModal, Datepicker, RejectOrder
	},
	data() {
		return {
			tabMenu:'',
			paramPickUp:{
				taken_date:'',
				taken_by:'',
				shipping_courier_number:'',
				shipping_courier_note_by_stockist:'',
			},
			msg: '',
			paramLimit:'',
			paramPage:1,
			paramStatus:'',
			currentLimit:10,
			status:'',
			limit:[5, 10, 20, 50, 100, 200],
			pilihanTipe:[{value:'0' , name: 'Pickup'},{value:'1' , name:'Shipping Courier'}],
			tanggalAwal:'',
			tanggalAkhir:'',
			tipe:{
				value:'',
				comparison:'=',
				type:'string',
				field:'trx_shipping_method'
			},
			kode:{
				value:'',
				comparison:'=',
				type:'string',
				field:'trx_code'
			},
			nama:{
				value:'',
				comparison:'like',
				type:'string',
				field:'trx_buyer_name'
			},
			tanggal:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'trx_datetime'
			},
			statusfilter:{
				value:'',
				comparison:'yes',
				type:'list',
				field:'trx_status'
			},
			params:[],
		}
	},

	computed: {
		...mapState('transactionList', ['transactionResults', 'transactionPagination', 'transactionOne', 'paramKonfProses', 'AlertKonfPickUpMsg','ProsesOrderAlert', 'dataProduct', 'cancelReason']),
		...mapGetters('auth', ['isAuth']),
	},

	methods: {
		...mapMutations('transactionList',['resetAlertKonfPickUp', 'setAlertKonfPickUp', 'errorProsesOrder', 'resetErrorProsesOrder']),
		...mapActions('transactionList', ['list', 'getTransactions', 'getOneTransaction', 'putProsesOrder', 'postNoResi', 'putActPickUp']),

		cekPickup() {
			this.resetAlertKonfPickUp()
			let alertPickup={}
			if(this.transactionOne.trx_shipping_method == 1) {
				if(!this.paramPickUp.shipping_courier_number && !this.paramPickUp.shipping_courier_note_by_stockist) {
					alertPickup = {
						'shipping_courier_number': "tidak boleh kosong!",
						'shipping_courier_note_by_stockist': "tidak boleh kosong!"
					}
				} else if(!this.paramPickUp.shipping_courier_number) {
					alertPickup = {
						'shipping_courier_number': "tidak boleh kosong!"
					}
				} else if(!this.paramPickUp.shipping_courier_note_by_stockist) {
					alertPickup = {
						'shipping_courier_note_by_stockist': "tidak boleh kosong!"
					}
				} else {
					this.$refs.konfirmasiPickup.modalShow(this.paramPickUp)
				}
			} else {
				if(!this.paramPickUp.taken_date && !this.paramPickUp.taken_by) {
					alertPickup = {
						'taken_date': "tidak boleh kosong!",
						'taken_by': "tidak boleh kosong!"
					}
				} else if(!this.paramPickUp.taken_date) {
					alertPickup = {
						'taken_date': "tidak boleh kosong!"
					}
				} else if(!this.paramPickUp.taken_by) {
					alertPickup = {
						'taken_by': "tidak boleh kosong!"
					}
				} else {
					this.$refs.konfirmasiPickup.modalShow()
				}
			}
			this.setAlertKonfPickUp(alertPickup)
		},

		PickupKonf(){
			this.resetAlertKonfPickUp()
			if(this.transactionOne.trx_shipping_method == 1) {
				this.postNoResi({"trx_id" : this.transactionOne.trx_id, "shipping_courier_number" : this.paramPickUp.shipping_courier_number, "shipping_courier_note_by_stockist" : this.paramPickUp.shipping_courier_note_by_stockist })
			} else {
				if(this.paramPickUp.taken_date) {
					this.putActPickUp({"trx_id" : this.transactionOne.trx_id, "taken_date": moment(this.paramPickUp.taken_date).format('YYYY-MM-DD'), "taken_by" : this.paramPickUp.taken_by})
				}
			}
			this.$refs.konfirmasiPickup.modalHide()
			this.$refs.ModalDetilTransaksi.modalHide()
			this.status = ''
		},

		prosesOrder(val){
			if (val == 4) {
				if (this.dataProduct.length > 0) {
					this.dataProduct.forEach( (element, index) => {
						if (element.totalNeeded != element.listSelected.length) {
							this.errorProsesOrder(`Jumlah Serial ${element.product.code} harus ${element.totalNeeded}`)
						}
						if (index == this.dataProduct.length - 1 && !this.ProsesOrderAlert) {
							this.$refs.konfirmasi.modalShow()
						}
					});
				} else {
					this.$refs.konfirmasi.modalShow()
				}
			} else if (val == 5) {
				if (!this.cancelReason) {
					this.errorProsesOrder(`Alasan Pembatalan tidak boleh kosong`)
				} else {
					this.$refs.konfirmasiPembatalan.modalShow()
				}
			}
		},

		prosesOrderSerial() {
			let params = {
				"trx_id" : this.transactionOne.trx_id,
				"status_code" : "4",
				"product" : [],
			}
			let product = this.transactionOne.products.map( element => {
				let serial = {}
				this.dataProduct.forEach( el => {
					if(el.product.code == element.code) {
						serial[el.type_id] = el.listSelected
					}
				})
				let data = {
					id : element.id,
					serial: serial
				}
				return data;
			});
			params.product = product

			this.$refs.konfirmasi.modalHide()
			this.putProsesOrder(params).then(()=>{
				this.$refs.konfirmasi.modalHide()
				this.tabMenu = 'detail'
			})
		},

		rejectOrder(){
			let params = {
				"trx_id" : this.transactionOne.trx_id,
				"status_code" : "5",
				"cancel_reason" : this.cancelReason,
			}

			this.putProsesOrder(params).then(() => {
				this.$refs.konfirmasiPembatalan.modalHide()
				this.tabMenu = 'detail'
			})
		},

		updateReason(val) {
			this.cancelReason = val
		},

		ChooseTabMenu(val) {
			this.tabMenu = val
		},

		detailTransaksi(trx_id) {
			this.paramPickUp = {
				taken_date:'',
				taken_by:'',
				shipping_courier_number:'',
				shipping_courier_note_by_stockist:'',
			}
			this.tabMenu = "detail"
			this.getOneTransaction(trx_id)
			this.$refs.ModalDetilTransaksi.modalShow();
		},

		cari(){
			this.currentLimit = 10
			this.params = []
			this.statusfilter.value = this.status
			if(this.statusfilter.value !== '') {
				this.params.push(this.statusfilter)
			}
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
				this.params.push(this.tanggal)
			}
			if(this.tipe.value) {
				this.params.push(this.tipe)
			}
			if(this.kode.value) {
				this.params.push(this.kode)
			}
			if(this.nama.value) {
				this.params.push(this.nama)
			}
			this.paramPage = 1
			this.getTransactions({params: this.params, limit: this.currentLimit, page: this.paramPage})
		},

		goToPage(val){
			this.paramPage = val
			this.getTransactions({params: this.params, limit: this.currentLimit, page: this.paramPage})
		},

		reset() {
			this.tipe.value=''
			this.kode.value=''
			this.nama.value=''
			this.tanggalAwal=''
			this.tanggalAkhir=''
			this.list()
		},

		getLimit(val) {
			this.currentLimit = val
			this.paramPage = 1
			this.getTransactions({params: this.params, limit: this.currentLimit, page: this.paramPage})
		},

		pilihStatus(value) {
			this.currentLimit = 10
			this.status = value
			this.statusfilter.value = value
			this.params.push(this.statusfilter)
			this.paramPage = 1
			this.getTransactions({params: this.params, limit: this.currentLimit, page: this.paramPage})
		},

		refresh(){
			this.getTransactions({params: this.params, limit: this.currentLimit, page: this.paramPage})
		}
	},

	watch: {
		ProsesOrderAlert(){
			if(this.ProsesOrderAlert){
				this.$refs.ProsesOrderEror.modalShow();
			} else {
				this.$refs.ProsesOrderEror.modalHide();
			}
		},
	},

	created() {
		this.list()
		this.$store.dispatch('setPageTitle', `Transaksi`);
	},
	
	beforeDestroy() {
		/* this.reset(); */
	}
};
</script>

<style>
.page-link.active {
	z-index: 2;
	color: #0056b3;
	text-decoration: none;
	background-color: #e9ecef;
	border-color: #dee2e6;
}

</style>
